export default {
  name: 'structured-data',
  computed: {
    data () {
      let sd = ''
      let r = this.$route

      // This switch checks the "name" property on the route, as defined in "routes.js". Make sure to map these properly
      // in the structured-data store (src/stores/structured-data.js).
      switch (r.name) {
        case 'index':
          sd = this.$store.getters.structuredDataIndex
          break
        case 'posters':
          break // @todo Implement
        case 'poster':
          switch (r.params.poster) {
            case 'babyroo':
              sd = this.$store.getters.structuredDataProductBabyroo
              break
            case 'foxy-strollin':
              sd = this.$store.getters.structuredDataProductFoxyStrollin
              break
            case 'peekaboo':
              sd = this.$store.getters.structuredDataProductPeekaboo
              break
            case 'mockingbird':
              sd = this.$store.getters.structuredDataProductMockingbird
              break
            case 'owlin-for-you':
              sd = this.$store.getters.structuredDataProductOwlinForYou
              break
            case 'retro-baby':
              sd = this.$store.getters.structuredDataProductRetroBaby
              break
            case 'scandinavian-forest':
              sd = this.$store.getters.structuredDataProductScandinavianForest
              break
            case 'born-strong':
              sd = this.$store.getters.structuredDataProductBornStrong
              break
            case 'what-the-fox-say':
              sd = this.$store.getters.structuredDataProductWhatTheFoxSay
              break
            case 'shorty-and-stretch':
              sd = this.$store.getters.structuredDataProductShortyAndStretch
              break
            case 'adorable':
              sd = this.$store.getters.structuredDataProductAdorable
              break
            case 'playful':
              sd = this.$store.getters.structuredDataProductPlayful
              break
            case 'delightful':
              sd = this.$store.getters.structuredDataProductDelightful
              break
            case 'rosette':
              sd = this.$store.getters.structuredDataProductRosette
              break
            case 'blossom-a':
              sd = this.$store.getters.structuredDataProductBlossomA
              break
            case 'blossom-b':
              sd = this.$store.getters.structuredDataProductBlossomB
              break
            case 'blossom-c':
              sd = this.$store.getters.structuredDataProductBlossomC
              break
            case 'blossom-d':
              sd = this.$store.getters.structuredDataProductBlossomD
              break
            case 'blossom-e':
              sd = this.$store.getters.structuredDataProductBlossomE
              break
            case 'blossom-f':
              sd = this.$store.getters.structuredDataProductBlossomF
              break
            case 'blossom-g':
              sd = this.$store.getters.structuredDataProductBlossomG
              break
            case 'blossom-h':
              sd = this.$store.getters.structuredDataProductBlossomH
              break
            case 'blossom-i':
              sd = this.$store.getters.structuredDataProductBlossomI
              break
            case 'blossom-j':
              sd = this.$store.getters.structuredDataProductBlossomJ
              break
            case 'blossom-k':
              sd = this.$store.getters.structuredDataProductBlossomK
              break
            case 'blossom-l':
              sd = this.$store.getters.structuredDataProductBlossomL
              break
            case 'blossom-m':
              sd = this.$store.getters.structuredDataProductBlossomM
              break
            case 'blossom-n':
              sd = this.$store.getters.structuredDataProductBlossomN
              break
            case 'blossom-o':
              sd = this.$store.getters.structuredDataProductBlossomO
              break
            case 'blossom-p':
              sd = this.$store.getters.structuredDataProductBlossomP
              break
            case 'blossom-q':
              sd = this.$store.getters.structuredDataProductBlossomQ
              break
            case 'blossom-r':
              sd = this.$store.getters.structuredDataProductBlossomR
              break
            case 'blossom-s':
              sd = this.$store.getters.structuredDataProductBlossomS
              break
            case 'blossom-t':
              sd = this.$store.getters.structuredDataProductBlossomT
              break
            case 'blossom-u':
              sd = this.$store.getters.structuredDataProductBlossomU
              break
            case 'blossom-v':
              sd = this.$store.getters.structuredDataProductBlossomV
              break
            case 'blossom-w':
              sd = this.$store.getters.structuredDataProductBlossomW
              break
            case 'blossom-x':
              sd = this.$store.getters.structuredDataProductBlossomX
              break
            case 'blossom-y':
              sd = this.$store.getters.structuredDataProductBlossomY
              break
            case 'blossom-z':
              sd = this.$store.getters.structuredDataProductBlossomZ
              break
            case 'blossom-aring':
              sd = this.$store.getters.structuredDataProductBlossomAring
              break
            case 'blossom-auml':
              sd = this.$store.getters.structuredDataProductBlossomAuml
              break
            case 'blossom-ouml':
              sd = this.$store.getters.structuredDataProductBlossomOuml
              break
            case 'blossom-aelig':
              sd = this.$store.getters.structuredDataProductBlossomAelig
              break
            case 'blossom-oslash':
              sd = this.$store.getters.structuredDataProductBlossomOslash
              break
            case 'blossom-yuml':
              sd = this.$store.getters.structuredDataProductBlossomYuml
              break
          }
          break
      }
      return JSON.stringify(sd)
    }
  },
  mounted () {
    // Move the component to "head".
    this.$el.remove()
    document.querySelector('head').appendChild(this.$el)
  }
}



// WEBPACK FOOTER //
// ./src/components/structured-data/script.js